import { NeedsApproval } from "../NeedsApproval";
import Section from "./Section";

import type { ConfigSection } from "../ConfigSectionHelp";
import type { Agent } from "@/shared/types";

/* Needs approval — a draft field; the run waits for a person before each call it names. */
export default function ApprovalSection({ agent, onUpdateAgent, onHelp }: {
  agent: Agent;
  onUpdateAgent: (updater: (a: Agent) => Agent) => void;
  onHelp: (section: ConfigSection) => void;
}) {
  return (
    <Section section="approval" onHelp={onHelp}>
      <NeedsApproval agent={agent} onChange={(needsApproval) => onUpdateAgent((a) => ({ ...a, needsApproval }))} />
    </Section>
  );
}
